import { render, staticRenderFns } from "./bellCurveItem.vue?vue&type=template&id=3997b4f4"
import script from "./bellCurveItem.vue?vue&type=script&lang=js"
export * from "./bellCurveItem.vue?vue&type=script&lang=js"
import style0 from "./bellCurveItem.vue?vue&type=style&index=0&id=3997b4f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports